var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"image"),React.createElement("g",{"id":"desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"ABOUT","transform":"translate(-219.000000, -3207.000000)","fill":"#363636","fillRule":"nonzero"},React.createElement("g",{"id":"image","transform":"translate(219.000000, 3207.000000)"},React.createElement("polygon",{"id":"Path","points":"10.428 34.45 11.328 23.56 0.528 24.82 8.718 17.71 0.528 10.51 11.328 11.86 10.428 0.97 17.268 9.43 24.198 0.97 23.208 11.86 34.008 10.51 25.818 17.71 34.008 24.82 23.208 23.56 24.198 34.45 17.268 25.9"}))))]);
}

StarInline.defaultProps = {"className":"starsvg","width":"35px","height":"35px","viewBox":"0 0 35 35","version":"1.1"};

module.exports = StarInline;

StarInline.default = StarInline;
